var _path, _path2, _path3, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLines(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 33.76 33.6",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m28.08 33.6v-33.6h5.68v33.6z",
    fill: "#1c488a"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m19.72 33.6v-33.6h4.1v33.6z",
    fill: "#4184d6"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m12.78 33.6c.02-9.99.05-19.97.07-29.96 0-1.17 0-2.41 0-3.65h2.93v33.6h-3z",
    fill: "#1c488a"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#4184d6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m6.15 33.6v-33.6h2.05v33.6z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m0 0h1.42v33.6h-1.42c0-11.2 0-22.4 0-33.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLines);
export default __webpack_public_path__ + "static/media/lines.30b0712bb704896c7447485055813602.svg";
export { ForwardRef as ReactComponent };